export const getFileData = (files, checklists) => {
  var issues = 0;
  var observations = 0;
  var comments = 0;
  var equipment = 0;
  var checkLists = 0;

  checklists.forEach((cl) => {
    checkLists += cl.hasOwnProperty("rows")
      ? cl.rows.filter(
          (row) =>
            row.hasOwnProperty("value") &&
            row.value.hasOwnProperty("url") &&
            row.value.url.length > 0 &&
            row["Row Type"] !== "Header" &&
            row["Row Type"] !== "Information Row",
        ).length
      : 0;
  });

  files.forEach((fl) => {
    if (fl.hasOwnProperty("issue_id") && fl.issue_id.length > 0) {
      issues += 1;
    } else if (
      fl.hasOwnProperty("observation_id") &&
      fl.observation_id.length > 0
    ) {
      observations += 1;
    } else if (fl.hasOwnProperty("comment_id") && fl.comment_id.length > 0) {
      comments += 1;
    } else if (
      fl.hasOwnProperty("equipment_id") &&
      fl.equipment_id.length > 0
    ) {
      equipment += 1;
    } else if (
      fl.hasOwnProperty("checklist_id") &&
      fl.checklist_id.length > 0
    ) {
      checkLists += 1;
    }
  });

  return [
    {
      order: 1,
      name: `Equipment Files (${equipment})`,
      value: equipment,
      color: "#349fda",
    },
    {
      order: 2,
      name: `Observation Files (${observations})`,
      value: observations,
      color: "#fdd835",
    },
    {
      order: 3,
      name: `Issue Files (${issues})`,
      value: issues,
      color: "#ff9800",
    },
    {
      order: 4,
      name: `Checklist Files (${checkLists})`,
      value: checkLists,
      color: "#7e57c2",
    },
    {
      order: 5,
      name: `Comment Files (${comments})`,
      value: comments,
      color: "#50C878",
    },
  ];
};
